import { token } from '@cp/shared/di';
import { FavoritesService } from './model';

export const FAVORITES_SERVICE = token<FavoritesService>('favorites/SERVICE');
